import React from 'react';
import Select from 'react-select';

var CustomSelect = function CustomSelect(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Select, {
    options: options,
    onChange: onChange
  });
};

export default CustomSelect;